import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'
import { connect } from 'react-redux'
import { closePopover } from '../../actions/popover'
import { openModal } from '../../actions/modal'
import { fetchManagedBusinesses } from '../../actions/businesses'
import { me, meBusinesses } from '../../initial_state'
import { MODAL_DISPLAY_OPTIONS } from '../../constants'
import PopoverLayout from './popover_layout'
import List from '../list'
import DisplayName from '../display_name'
import Button from '../button'
import Text from '../text'
import Avatar from '../avatar'
import LinkFooter from '../link_footer'
import Image from '../image'

class NavSettingsPopover extends React.PureComponent {

  componentDidMount() {
   this.props.onFetchManagedBusinesses()
  }

  handleOnClosePopover = () => {
    this.props.onClosePopover()
  }

  handleOpenDisplayOptions = () => {
    this.props.onOpenDisplayOptions()
    this.handleOnClosePopover()
  }

  render() {
    const { account, managedBusinesses, isXS } = this.props

    if (isXS) return null

    return (
      <PopoverLayout width={340}>
        <div className={[_s.d, _s.w100PC, _s.py10, _s.px10].join(' ')}>
          
          <NavLink
            className={[_s.d, _s.flexRow, _s.cursorPointer, _s.border1PX, _s.borderColorSecondary, _s.boxShadowBlock, _s.noUnderline, _s.bgSubtle_onHover, _s.radiusSmall, _s.px5, _s.py10].join(' ')}
            to={`/${account.get('acct')}`}
          >
            <div className={[_s.d, _s.circle, _s.borderColorPrimary].join(' ')}>
              <Avatar account={account} size={40} noHover />
            </div>
            <div className={[_s.d, _s.ml10].join(' ')}>
              <DisplayName account={account} isMultiline noRelationship noHover />
            </div>
          </NavLink>

          {
            managedBusinesses && managedBusinesses.map((business) => {
              return (
                <NavLink
                  className={[_s.d, _s.overflowHidden, _s.mt10, _s.flexRow, _s.cursorPointer, _s.border1PX, _s.borderColorSecondary, _s.boxShadowBlock, _s.noUnderline, _s.bgSubtle_onHover, _s.radiusSmall, _s.px5, _s.py10].join(' ')}
                  to={`/business/${business.get('id')}`}
                >
                  <div className={[_s.d, _s.radiusTiny, _s.borderColorPrimary].join(' ')}>
                    <Image
                      src={business.get('logo_thumbnail_url')}
                      width={40}
                      height={40}
                      className={[_s.radiusTiny].join(' ')}
                    />
                  </div>
                  <div className={[_s.d, _s.ml10].join(' ')}>
                    <Text size='medium' weight='medium'>{business.get('name')}</Text>
                    <Text color='secondary' className={[_s.capitalize, _s.mt5].join(' ')}>{business.get('status')}</Text>
                  </div>
                </NavLink>
              )
            })
          }

        </div>
        <div className={[_s.d, _s.w100PC, _s.boxShadowNone, _s.borderBottom1PX, _s.borderColorSecondary].join(' ')}>
          <List
            scrollKey='profile_options'
            items={[
              {
                icon: 'cog',
                title: 'Settings & Privacy',
                href: '/settings/preferences',
              },
              {
                icon: 'group',
                title: 'Help & Support',
                href: 'https://help.gab.com',
              },
              {
                icon: 'light-bulb',
                title: 'Display options',
                onClick: this.handleOpenDisplayOptions,
              },
            ]}
          />
        </div>

        <div className={[_s.d, _s.w100PC, _s.py10, _s.px10].join(' ')}>
          <Button
            radiusSmall
            backgroundColor='secondary'
            color='primary'
            data-method='delete'
            href='/auth/sign_out'
          >
            <Text color='inherit' weight='medium' align='center'>Log out</Text>
          </Button>
        </div>

        <div className={[_s.d, _s.w100PC, _s.px10].join(' ')}>
          <LinkFooter />
        </div>
      </PopoverLayout>
    )
  }
}

const mapStateToProps = (state) => {
  const managedBusinessIds = state.getIn(['business_lists', 'managed', 'items'])
  const managedBusinesses = !!managedBusinessIds ? managedBusinessIds.map((bizId) => {
    return state.getIn(['businesses', 'items', bizId])
  }) : null

  return {
    account: state.getIn(['accounts', me]),
    managedBusinesses,
  }
}

const mapDispatchToProps = (dispatch) => ({
  onClosePopover() {
    dispatch(closePopover())
  },
  onOpenDisplayOptions() {
    dispatch(openModal(MODAL_DISPLAY_OPTIONS))
  },
  onFetchManagedBusinesses() {
    dispatch(fetchManagedBusinesses())
  },
})

NavSettingsPopover.propTypes = {
  onClosePopover: PropTypes.func.isRequired,
  isXS: PropTypes.bool,
}

export default connect(mapStateToProps, mapDispatchToProps)(NavSettingsPopover)